module.exports = __webpack_public_path__ + "img/aesssa-logo.9a84dc46.png";